import ReactDOM from 'react-dom/client';
import './index.css';
import { Home } from './Screens/Home';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Home />);

